import * as React from "react";
import classnames from "classnames";
import * as styles from "./styles.scss";

interface IInputProps {
  onSubmit?: any;
  method?: string;
  action?: string;
  style?: any;
  id?: any;
  encType?: any;
}

export class Form extends React.Component<IInputProps, {}> {
  render() {
    const { ...formProps } = this.props;
    const className = classnames({
      [styles.Form]: true
    });

    return <form className={className} {...formProps} />;
  }
}
